export default Object.freeze({
  bySiteAndDate: [],
  byDate: [],
  bySite: [],
  scheduleStatistics: [],
  byEmployee: [],
  list: [],
  loading: true,
});
